import {observable} from "@legendapp/state";

export const $currentAttendanceId = observable<string | undefined>();
export const $viewingAttendanceId = observable<string | undefined>();
